import React from 'react';
import { Select , Form} from 'antd';

const Option = Select.Option;
const FormItem = Form.Item;

const SelectCustom = ({size, option, showSearch, placeholder, label, marginBottom="8", labelColor="85", onChange, mode="default", className, ...rest }) => (
    <FormItem label={label} className={`form-label margin-bottom${marginBottom} label-color${labelColor}`}>
        <Select
            { ...rest }
            mode={mode}
            showSearch={showSearch}
            placeholder={placeholder}
            size={size}
            className={`select ${className ? className : ''}`}
            dropdownClassName="select-dropdown"
            onChange={onChange}
            >
            {option.map((list, index) => (
                <Option key={index} value={list.value}>{list.label}</Option>
            ))}
        </Select>
    </FormItem>
);

export default SelectCustom;